import getManagerPermissions from "v2/infrastructure/common/repositories/getManagerPermissions/getManagerPermissions";
import { ManagerPermission } from "../../entities/ManagerPermission/ManagerPermission";

const findManagerPermissions = async (): Promise<ManagerPermission> => {
  const emptyManagerPermissions = new ManagerPermission();
  const managerPermissions = await getManagerPermissions();

  return managerPermissions ?? emptyManagerPermissions;
};

export default findManagerPermissions;
